export const environment = {
  production: true,
  env: "prod",
  apiHost: "https://api.qa-staging.zceppa.com/",
  adminApiHost: "https://admin-api.qa-staging.zceppa.com/",
  widgetDomain: "https://qawidget.zceppa.com/",
  spritePath: "assets/sprites/sprite.svg",
  fbAppId: "2262024527378539",
  pusher: {
    key: "010d0565b3d2f39e34df",
    cluster: "ap2",
  }
};
